import React from 'react';

let DashboardPage = () => {

    return <div className='wrapper'>
        <p style={{color: 'red'}}>Dashboard</p>
    </div>
}

export default DashboardPage;